import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=d24689f4&scoped=true&"
import script from "./Chart.vue?vue&type=script&lang=js&"
export * from "./Chart.vue?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=d24689f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24689f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d24689f4')) {
      api.createRecord('d24689f4', component.options)
    } else {
      api.reload('d24689f4', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=d24689f4&scoped=true&", function () {
      api.rerender('d24689f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Graphs/Chart.vue"
export default component.exports